export default {
  name: 'specialTag',
  uniqKey: '_id',
  crudMapping: {
    readMany: 'specialTags',
    readOne: 'tag',
    update: 'updateSpecialTag',
  },
  readManySchema: {
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Tag',
      type: 'object',
      required: [
        'title',
        'score',
      ],
      properties: {
        title: {
          type: 'string',
        },
        score: {
          type: 'number',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/specialTag.js